import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {ausbildungProgress} from 'ag-common/tools/ausbildungProgress'
import {format} from 'ag-common/facades'

export default function AusbildungFortschritt(props) {
  const start = new Date(props.start)
  const end = new Date(props.end)
  const progressPercentage = ausbildungProgress(start, end)
  const fillStyle = {
    width: `${progressPercentage}%`,
  }

  return (
    <div className="ausbildung-fortschritt">
      <div className="progress-text">
        <span className="progress-percentage">
          {i18n.t('meineausbildung_progress_percentage', [progressPercentage])}
        </span>
        {i18n.t('meineausbildung_progress_text')}
      </div>
      <div className="progress-bar">
        <div className={`circle ${progressPercentage > 0 ? 'circle--filled' : ''}`} />
        <div className="meter">
          <span className="fill" style={fillStyle} />
        </div>
        <div className={`circle ${progressPercentage >= 100 ? 'circle--filled' : ''}`} />
      </div>
      <div className="dates">
        <span className="start-date">{format(start, 'dd.MM.yyyy')}</span>
        <span className="end-date">{format(end, 'dd.MM.yyyy')}</span>
      </div>
    </div>
  )
}

AusbildungFortschritt.propTypes = {
  start: PropTypes.instanceOf(Date),
  end: PropTypes.instanceOf(Date),
}
